"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _lodash = require("lodash");

var ValidationService = /*#__PURE__*/function () {
  function ValidationService() {
    (0, _classCallCheck2.default)(this, ValidationService);
    this.EMAIL_REGEX = /^[^\s@]+@[^\s@]{2,}\.[^\s@]{2,}$/;
    this.PHONE_NUMBER_REGEX = /^(\+1)?[0-9]{10}$/;
    this.ZIP_CODE_REGEX = /^[A-Za-z][0-9][A-Za-z][0-9][A-Za-z][0-9]$/;
    this.CREDIT_CARD_NUMBER_REGEX = /^([0-9\s]{15,16})$/;
    this.CREDIT_CARD_CVC_REGEX = /^[0-9]{3,4}$/;
    this.YEAR_REGEX = /^[0-9]{4}$/;
    this.ODOMETER_REGEX = /^[0-9]{1,7}$/;
    this.VIN_REGEX = /^([A-z0-9]{17})?$/;
    this.EXPIRATION_DATE_REGEX = /^(1[0-2]|0[1-9]|\d)\/(2\d{3}|19\d{2})$/;
    this.INTEGER_REGEX = /^([+-]?[1-9]\d*|0)$/;
    this.validateCardNumber = this.validateCardNumber.bind(this);
    this.validateCardValidationCode = this.validateCardValidationCode.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.validateOdometer = this.validateOdometer.bind(this);
    this.validatePhoneNumber = this.validatePhoneNumber.bind(this);
    this.validateVin = this.validateVin.bind(this);
    this.validateYear = this.validateYear.bind(this);
    this.validateZipCode = this.validateZipCode.bind(this);
    this.validateExpirationDate = this.validateExpirationDate.bind(this);
    this.checkForErrors = this.checkForErrors.bind(this);
    this.validateIsInteger = this.validateIsInteger.bind(this);
  }

  (0, _createClass2.default)(ValidationService, [{
    key: "validateIsInteger",
    value: function validateIsInteger(value) {
      return this.validateIsNotEmpty(value) && this.INTEGER_REGEX.test(value);
    }
  }, {
    key: "validateCardNumber",
    value: function validateCardNumber(value) {
      return this.validateIsNotEmpty(value) && (0, _lodash.isString)(value) && this.CREDIT_CARD_NUMBER_REGEX.test(value);
    }
  }, {
    key: "validateCardValidationCode",
    value: function validateCardValidationCode(value) {
      return this.validateIsNotEmpty(value) && (0, _lodash.isString)(value) && this.CREDIT_CARD_CVC_REGEX.test(value);
    }
  }, {
    key: "validateEmail",
    value: function validateEmail(value) {
      return (0, _lodash.isString)(value) ? this.EMAIL_REGEX.test(value) : false;
    }
  }, {
    key: "validateIsNotEmpty",
    value: function validateIsNotEmpty(value) {
      if ((0, _lodash.isString)(value)) {
        return value.trim().length !== 0;
      }

      if ((0, _lodash.isNumber)(value)) {
        return isFinite(value); // eslint-disable-line no-restricted-globals
      }

      if ((0, _lodash.isBoolean)(value)) {
        return true;
      }

      if ((0, _lodash.isArray)(value) || (0, _lodash.isPlainObject)(value) || (0, _lodash.isMap)(value) || (0, _lodash.isSet)(value)) {
        return !(0, _lodash.isEmpty)(value);
      }

      return !!value;
    }
  }, {
    key: "validateOdometer",
    value: function validateOdometer(value) {
      return this.validateIsNotEmpty(value) && this.ODOMETER_REGEX.test(value) && parseInt(value, 10) > 0;
    }
  }, {
    key: "validatePhoneNumber",
    value: function validatePhoneNumber(value) {
      return this.validateIsNotEmpty(value) && (0, _lodash.isString)(value) && this.PHONE_NUMBER_REGEX.test(value);
    }
  }, {
    key: "validateVin",
    value: function validateVin(value) {
      return this.validateIsNotEmpty(value) ? this.VIN_REGEX.test(value) : true;
    }
  }, {
    key: "validateExpirationDate",
    value: function validateExpirationDate(value) {
      var match = this.validateIsNotEmpty(value) && this.EXPIRATION_DATE_REGEX.test(value);

      if (match) {
        var splittedDate = value.split('/');
        var month = splittedDate[0];
        var formattedMonth = Number(month);
        var year = splittedDate[1];
        var expiration = new Date(year, formattedMonth - 1, 1);
        var now = new Date();
        var currentMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        var isValid = currentMonth <= expiration;
        return isValid;
      }

      return false;
    }
  }, {
    key: "validateYear",
    value: function validateYear(value) {
      return this.validateIsNotEmpty(value) && this.YEAR_REGEX.test(value);
    }
  }, {
    key: "validateZipCode",
    value: function validateZipCode(value) {
      return (0, _lodash.isString)(value) ? this.ZIP_CODE_REGEX.test(value.replace(' ', '')) : false;
    }
  }, {
    key: "checkForErrors",
    value: function checkForErrors(values, fieldValidators) {
      var _this = this;

      var errors = Object.keys(fieldValidators).reduce(function (accum, fieldName) {
        var validatorFunction = _this[fieldValidators[fieldName]];
        var isValid = validatorFunction(values[fieldName]);

        if (!isValid) {
          accum[fieldName] = true;
        }

        return accum;
      }, {});
      return errors;
    }
  }]);
  return ValidationService;
}();

var _default = new ValidationService();

exports.default = _default;